import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BOToothStateDetail } from '../../../models/odo/BOToothStateDetail.model';
import { BOToothStateType } from '../../../models/odo/BOToothStateType.model';
import { BOToothType } from '../../../models/odo/BOToothType.model';
import { BOToothStateDetailToothFace } from '../../../models/odo/BOToothStateDetailToothFace.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.css']
})

//export class PatientFarmacologicRecordComponent implements OnInit, OnChanges {
 export class QuotationComponent implements OnInit {

  @Input() id!: number;
    @Input() posInArray!:number;
    @Input() item: BOToothStateDetail;
    @Input() toothStateTypeList: BOToothStateType[]=[];
    @Input() toothTypeList: BOToothType[]=[];

    @Output() posSendedId = new EventEmitter<{item:BOToothStateDetail, tipo:string}>(); // ← Cambia el tipo
    its= new BOToothStateDetail();

    toothStateFormGroup = this._formBuilder.group({
        posInArray:{ value: null, disabled: true },
        toothType:{value: null, disabled:true},
        toothStateType:{value: null, disabled:true},
        faces: { value: null, disabled: true },
        detail:{ value: null, disabled: false },
        fixed:{ value: null, disabled: false },
        price:{ value: null, disabled: false },
      });

  constructor( private _formBuilder : FormBuilder,   private _router: Router,

  ) { }

  ngOnInit(): void
  {
   //console.log("ENTRA AL NGONINIT DE QUOTATION, item es:", this.item);
  const toothTypeId=this.item.toothTypeId;
  const toothStateTypeId=this.item.toothStateId;
  const facesTemp=this.getFacesLetter(this.item.toothFaces);

  this.toothStateFormGroup.patchValue({
    posInArray:this.posInArray +1,
    toothType:this.toothTypeList.find(x=>x.id==toothTypeId).name,
    toothStateType:this.toothStateTypeList.find(x=>x.id==toothStateTypeId).name,
//    faces:this.getFacesLetter(this.item.toothFaces),
    faces:facesTemp,

    detail:this.item.observations,
    fixed:this.item.fixed,
    price:this.item.price
  })

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.toothStateFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }

  getFacesLetter(lst: BOToothStateDetailToothFace[]): string {
    // Si la lista viene vacía o nula, retornamos string vacío
    if (!lst || lst.length === 0) return '';

    // map() recorre cada elemento, getFaceLetter() devuelve la letra, y join(',') las une
    return lst.map(item => this.getFaceLetter(item.toothFaceId)).join(',');
  }

  // Cambiamos el nombre a getFaceLetter y solo le pasamos el ID directamente
  getFaceLetter(faceId: number): string {
    switch (faceId) {
      case 1: return "V";
      case 2: return "M";
      case 3: return "D";
      case 4: return "P";
      case 5: return "O";
      case 6: return "L";
      case 7: return "I";

      default: return ""; // Por si viene un ID no contemplado
    }
  }
  editItemSingle(): void {
    this.its=this.item;
    this.its.observations=this.toothStateFormGroup.get('detail').value;
    this.its.price=this.toothStateFormGroup.get('price').value;
    this.its.fixed=this.toothStateFormGroup.get('fixed').value;

    this.posSendedId.emit({ item:this.its, tipo:'edi' }); // ← Emite ID, no posición
  }

  deleteItemSingle(): void {
    this.posSendedId.emit({ item: this.item, tipo:'del'}); // ← Emite ID, no posición
  }




}

